<template>
  <div class="ver-imagen">
    <h3 class="text-center mb-3 font-weight-bold">Ver Item Procedimiento</h3>

    <b-card class="section-card">
      <h5 class="section-title">Información del Ítem</h5>
      <b-row class="mt-1">
        <b-col md="4" class="mb-1">
          <small class="text-muted d-block">Código</small>
          <span class="font-weight-bold h5 mb-0 d-block">{{ procItem.codigo || 'No disponible' }}</span>
        </b-col>
        <b-col md="4" class="mb-1">
          <small class="text-muted d-block">Especialidad</small>
          <span class="font-weight-bold h5 mb-0 d-block">{{ (procItem.especialidad && procItem.especialidad.descripcion) || 'No disponible' }}</span>
        </b-col>
        <b-col md="4" class="mb-1">
          <small class="text-muted d-block">Nombre</small>
          <span class="font-weight-bold h5 mb-0 d-block">{{ procItem.descripcion || 'No disponible' }}</span>
        </b-col>
      </b-row>
    </b-card>

    <b-card class="section-card">
      <h5 class="section-title">Precios</h5>
      <table class="table table-sm table-precios">
        <thead>
          <tr>
            <th>Entidad</th>
            <th class="text-right">Precio</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="fila in filasPrecios" :key="fila.entidad">
            <td class="font-weight-bold">{{ fila.entidad }}</td>
            <td class="text-right">{{ fila.precio }}</td>
          </tr>
        </tbody>
      </table>
    </b-card>

    <b-card class="section-card">
      <h5 class="section-title">Estados de Cobertura</h5>
      <div class="d-flex flex-wrap">
        <div class="estado-chip mr-4 mb-2" v-for="estado in estadosCobertura" :key="estado.label">
          <span :class="estado.activo ? 'text-success' : 'text-danger'">
            <i :class="estado.activo ? 'fas fa-check-circle' : 'fas fa-minus-circle'" class="mr-1"></i>
            {{ estado.label }}
          </span>
        </div>
      </div>
    </b-card>

    <b-card class="section-card">
      <h5 class="section-title">Establecimientos</h5>
      <b-row>
        <b-col md="6" v-for="est in establecimientos" :key="est.id">
          <div class="d-flex align-items-center mb-2">
            <span class="font-weight-bold mr-2 text-uppercase">{{ est.nombre }}</span>
            <span :class="est.activo ? 'text-success' : 'text-danger'">
              <i :class="est.activo ? 'fas fa-check-circle' : 'fas fa-times-circle'" class="mr-1"></i>
              {{ est.activo ? 'Activo' : 'Inactivo' }}
            </span>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import { comprobarPermisos } from "@/shared/helpers";
import { establecimientosService } from '@/views/administracion/services';
import { BRow, BCol, BCard } from 'bootstrap-vue';

export default {
  components: {
    BRow,
    BCol,
    BCard,
  },
  props: ['token'],
  data() {
    return {
      procedimiento: null,
      estadoJson: {},
      precioJson: {},
      establecimientosList: [],
    };
  },
  async created() {
    comprobarPermisos(this.$route);
    this.establecimientosList = await this.fetchEstablecimientos();
    await this.fetchProcedimiento(this.token);
  },
  methods: {
    async fetchEstablecimientos() {
      const query = `
        query {
          allEstablecimientos {
            id
            Descripcion
            uniCodigo
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + 'api', { query });
        const list = response.data.data.allEstablecimientos.map(item => ({
          value: item.id,
          text: item.Descripcion,
        }));
        return list;
      } catch (error) {
        console.error("Error cargando establecimientos", error);
        return [];
      }
    },

    parseFlexibleJson(value) {
      if (!value) return {};
      if (typeof value === 'object') return value;
      try {
        return JSON.parse(value);
      } catch (e) {
        try {
          const fixed = value.replace(/'/g, '"').replace(/([{,]\s*)([a-zA-Z0-9_]+)\s*:/g, '$1"$2":');
          return JSON.parse(fixed);
        } catch (err) {
          console.warn('No se pudo parsear JSON flexible', value);
          return {};
        }
      }
    },

    async fetchProcedimiento(token) {
      const query = `
        query GetProcedimiento($tokenproc: String!) {
          allProcs(tokenproc: $tokenproc) {
            total
            status
            message
            procedimiento{
              id
              token
              descripcion
              establecimiento
              especialidad {
                id
                descripcion
              }
              codigo
              estado
              precio
              precioJson
              estadoJson
            }
          }
        }
      `;

      const variables = { tokenproc: token };

      try {
        const response = await axios.post(rutas.axios + 'api', { query, variables });
        const data = response?.data?.data?.allProcs;
        if (data?.status === 'Success' && data.procedimiento?.length) {
          const proc = data.procedimiento[0];
          this.precioJson = this.parseFlexibleJson(proc.precioJson);
          this.estadoJson = this.parseFlexibleJson(proc.estadoJson);
          this.procedimiento = proc;
        } else {
          console.error("Error al obtener el procedimiento:", response.data.message);
        }
      } catch (error) {
        console.error("Error al realizar la consulta GraphQL:", error);
      }
    },
  },

  computed: {
    procItem() {
      return this.procedimiento || {};
    },
    filasPrecios() {
      const format = (valor) => {
        const num = Number(valor || 0);
        return `$${num.toFixed(2)}`;
      };
      return [
        { entidad: 'ISSFA N1', precio: format(this.precioJson.issfa_n1) },
        { entidad: 'ISSFA N2', precio: format(this.precioJson.issfa_n2) },
        { entidad: 'IESS N1',  precio: format(this.precioJson.iess_n1) },
        { entidad: 'ISSPOL N1', precio: format(this.precioJson.isspol_n1) },
        { entidad: 'PARTICULAR', precio: format(this.precioJson.particular) },
      ];
    },
    estadosCobertura() {
      return [
        { label: 'IESS',       activo: !!this.estadoJson.iess },
        { label: 'ISSFA',      activo: !!this.estadoJson.issfa },
        { label: 'ISSPOL',     activo: !!this.estadoJson.isspol },
        { label: 'PARTICULAR', activo: !!this.estadoJson.particular },
      ];
    },
    establecimientos() {
      const ids = (this.procItem.establecimiento || '').split(',').map(e => e.trim()).filter(Boolean);
      if (!this.establecimientosList || !this.establecimientosList.length) {
        return ids.map(id => ({ id, nombre: id, activo: true }));
      }
      return this.establecimientosList.map(est => ({
        id: est.value ? String(est.value) : '',
        nombre: est.text,
        activo: ids.includes(String(est.value)),
      }));
    },
  },
};
</script>

<style scoped>
.ver-imagen h5 {
  font-weight: 600;
}
.section-card {
  background: #f7f9fc;
}
.section-title {
  font-weight: 700;
  margin-bottom: 6px;
}
.table-precios thead th {
  background: #dfe3e8;
}
.estado-chip {
  padding: 4px 0;
}
</style>
